import { render, staticRenderFns } from "./ProductForward.vue?vue&type=template&id=692c03f4&scoped=true&"
import script from "./ProductForward.vue?vue&type=script&lang=js&"
export * from "./ProductForward.vue?vue&type=script&lang=js&"
import style0 from "./ProductForward.vue?vue&type=style&index=0&id=692c03f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "692c03f4",
  null
  
)

export default component.exports